export let dataProps = {
    id: 0,
    first_name: '',
    last_name: '',
    email_address: '',
    country_id: 0,
    mobile_number: '',
    brand_name: '',
    number_of_stores: 1,
    production_type: 0, //self or outsourcing
    garment_type: 0, //western, indo-western, Ethnic Wear, or others
    gender_type: 0, //men, women, both
    rep_id: null,
    logs: [],
    status: 0,
    log_text: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/leads/properties.js